import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { AppComponentGenericComponent } from '../custom/app-component-generic/app-component-generic.component';
import { TableGenericComponent } from '../custom/table-generic/table-generic.component';

import { DataService } from '../../services/data.service';

import { GenericExternalCommandType } from '../../models/generic-external-command';
import { AnagraficaTableField } from '../../models/library-table-field';
import { createMasterAnimation, createDetailAnimation } from '../../animations/master-detail.animation';
import { Person } from '../../models/person';

@Component({
  selector: 'app-anagrafica',
  templateUrl: './anagrafica.component.html',
  styleUrls: ['./anagrafica.component.css'],
  animations: [
    createMasterAnimation('masterSlider'),
    createDetailAnimation('detailSlider'),
  ]
})
export class AnagraficaComponent extends AppComponentGenericComponent implements OnInit {
    @ViewChild('mw') mw: any;
    @ViewChild('filterBoxGeneric') filterBoxGeneric: any;

    // Sync
    anagrafica: Person[] = [];
    anagraficaSync: Subscription;

    // Detail
    personSelected: Person;

    // FilterBox
    externCommands: Map<string, GenericExternalCommandType> = null;

    // Table
    tableFields: AnagraficaTableField;
    anagraficaFiltered: Person[] = [];
    ngClassRow = "\"{'color-societa': row.societa, 'color-person': !row.societa }\"";

    // Modal
    modalInput: any;

    constructor(protected dataService: DataService) {
	super(dataService, 'anagrafica');
	this.modalInput = {
	    size: 'modal-95',
	    title: 'Titolo',
	    subtitle: 'sottotitolo',
	    data: {
		id: 0,
		person: null,
		id_prat: null,
		reset: false,
	    }
	};
    }

    ngOnInit() {
	this.personSelected = null;
	this.externCommands = new Map();
	this.tableFields = new AnagraficaTableField();
	this.headerFields = this.tableFields.getHeader();
	this.footerFields = this.tableFields.getFooter();
	this.writePermission = this.checkPermission('anagrafica','write');

	// set and update inter-comunication parameters
	//console.log("parametri", this.parametri);
	this.parametri.setDettaglioView(Boolean(this.personSelected));
	this.parametri.setTypeFilter("anagrafica");
	this.parametri.setTitleBox("Anagrafica Contribuenti");
	this.parametri.setNumFilteredTxt("Posizioni");
	if(this.writePermission){
	    let externCommandLocal = new GenericExternalCommandType();
	    externCommandLocal.setAllValue("anagrafica-dettaglio", "add", "add", "Nuovo Contribuente", false);
		this.externCommands.set('nuovo-contribuente', externCommandLocal);
		let esportaAnagraficheCommand = new GenericExternalCommandType();
		esportaAnagraficheCommand.setAllValue("", "cloud_download", "esporta-anagrafiche", "Esporta Anagrafiche", false);
		this.externCommands.set('esporta-anagrafiche', esportaAnagraficheCommand);
	    this.parametri.setWritePermission(true);
	}
	this.parametri.setExternCommands(this.externCommands);
	this.updateParametri();

	// Sync data
	this.anagraficaSync = this.dataService.getContribuentiService().anagrafica$
	.subscribe(
	    anagrafica => {
		//this.personSelected = null;
		this.parametri.setDettaglioView(Boolean(this.personSelected));
		this.parametri.setDataArraySource(anagrafica);
		this.updateParametri();
	    }
	);
    }

    apriModifica(person: any){
	console.log('anagrafica modifica person', person, this.writePermission);
	this.personSelected = person;
	this.parametri.setDettaglioView(Boolean(this.personSelected));
	this.updateParametri();
	this.changeAnimationState();
    }

    apriNuovo(){
	let person = new Person();
	console.log('anagrafica new person', person, this.writePermission);
	this.personSelected = person;
	this.parametri.setDettaglioView(Boolean(this.personSelected));
	this.updateParametri();
	this.changeAnimationState();
    }

    getModalOutput($event){
	console.log("Anagrafica getModalOutput", $event);
    }

    manageEventFilterBox($event){
	//console.log("manageEventFilterBox", $event);
	if($event){
	    switch($event.type){
		case 'filterResult':
		    this.anagraficaFiltered = ($event.data) ? $event.data : [];
		    //console.log("anagraficaFiltered", this.anagraficaFiltered);
		    this.tableFields.generateFooterRow();
		    this.footerFields = this.tableFields.getFooter();
		    break;
		case 'action':
		    let dataCommand = $event.data;
		    let codeCommand = dataCommand.code;
		    let typeCommand = dataCommand.type;
		    let textCommand = dataCommand.text;
		    switch(typeCommand) {
			case 'add':
			    this.apriNuovo();
			    break;
			case 'esporta-anagrafiche':
			    this.exportCsv();
			    break;
		    }
		    //console.log("anagrafica action", this.modalInput);
		    //if (codeCommand.length) {
		    //	this.mw.show(codeCommand, this.modalInput);
		    //}
		    break;
		case 'new-action':
		    console.log("anagrafica new-action");
		    break;
		default:
		    console.log("type non riconosciuto!");
	    }
	}
    }

    manageEventInner(event: any) {
	console.debug("Anagrafica manageEventInner:", event);
	if(event.resetState){
	    this.resetAnimationState();
	    this.personSelected = null;
	    this.parametri.setDettaglioView(Boolean(this.personSelected));
	    this.updateParametri();
	}
    }

    exportCsv() {
	let filename = "anagrafiche";
	let data = [];
	for (let anagrafica of this.anagraficaFiltered) {
	    let item = {}
	    item['ID'] = anagrafica.anagrafica_id;
	    item['Codice Fiscale'] = anagrafica.codice_fiscale;
	    item['Cognome'] = anagrafica.cognome;
	    item['Nome'] = anagrafica.nome ? anagrafica.nome : "";
	    item['Indirizzo'] = anagrafica.indirizzo_completo ? anagrafica.indirizzo_completo : "";
	    item['Comune'] = anagrafica.comune ? anagrafica.comune : "";
	    item['Provincia'] = anagrafica.prov ? anagrafica.prov : "";
	    item['CAP'] = anagrafica.cap ? anagrafica.cap : "";
	    item['Email'] = anagrafica.email ? anagrafica.email : "";
	    item['Telefono'] = anagrafica.telefono ? anagrafica.telefono : "";
	    item['Comune Nascita'] = anagrafica.nascita_comune ? anagrafica.nascita_comune : "";
	    item['Provincia Nascita'] = anagrafica.nascita_prov ? anagrafica.nascita_prov : "";
	    item['Data Nascita'] = anagrafica.nascita_data ? anagrafica.nascita_data : "";
	    item['Data Decesso'] = anagrafica.decesso_data ? anagrafica.decesso_data : "";
	    item['Aggiornato'] = anagrafica.aggiornamento_data_ridotta_view ? anagrafica.aggiornamento_data_ridotta_view : "";
	    data.push(item);
	}
	this.dataService.exportCsv(filename,data);
    }

    ngOnDestroy() {
	this.anagraficaSync.unsubscribe();
    }
}
